const $ = jQuery

$(document).ready(function() {
  setInterval(function(){
    $('.gm-style-iw').parent().on('click', function(){
      $(this).css({'z-index': 99});
    });
  },1000);
  
  //Adicionado por Marcelo
  $('.gm-style-iw').parent().addClass('ajuste-ficha');
  // Joga para frente a InfoWindow clicada no mapa
  $(document).on('click', '.gm-style-iw, .gm-style-iw > *', function() {
    $('.gm-style-iw').parent().css('z-index', '1');
    $(this).parent().css('z-index', '10');
  });
  
  if( $('.floater-back:visible').length > 0 ) {
    $('*').click(function() { $('.floater-back').hide('slow'); });
  }
});